import { DELISTED_STATUS } from '@seller/shared';
import { day } from '../format.js';

/**
 * A SKU's effective status in a table cell. Amazon's own status reads as plain
 * text; "No longer listed" (a full All Listings import left the SKU out — it was
 * deleted in Seller Central) reads as a muted chip, with the day it was noticed
 * and Amazon's last status in the tooltip when the row carries them.
 */
export function SkuStatus({
  status,
  delistedOn,
  listingStatus,
}: {
  status: string | null;
  delistedOn?: string | null;
  /** Amazon's own last-known status, for the tooltip. */
  listingStatus?: string | null;
}) {
  if (status !== DELISTED_STATUS) return <>{status ?? '—'}</>;
  const parts = [
    delistedOn
      ? `Left out of the All Listings import of ${day(delistedOn)}: deleted in Seller Central.`
      : 'Left out of a full All Listings import: deleted in Seller Central.',
  ];
  if (listingStatus) parts.push(`Amazon's last status: ${listingStatus}.`);
  parts.push('History is kept; the next listings file that carries it lists it again.');
  return (
    <span
      className="inline-flex items-center whitespace-nowrap rounded bg-raised px-1.5 py-0.5 text-xs font-medium text-muted ring-1 ring-inset ring-line"
      title={parts.join(' ')}
      data-testid="sku-status-delisted"
    >
      {DELISTED_STATUS}
    </span>
  );
}
